/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.2)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: AuthenticateRequest | undefined): Promise<JwtClientToken> {
        let url_ = this.baseUrl + "/api/Account/api/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<JwtClientToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtClientToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtClientToken>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: AuthenticateRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Account/api/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validate(body: JwtClientToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Account/api/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    user(userId: number | undefined): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/Account/api/user?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    guid(userId: string | null | undefined): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/Account/api/user/guid?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGuid(_response);
        });
    }

    protected processGuid(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @param documentId (optional) 
     * @return Success
     */
    document(token: string | null | undefined, receiptId: string | undefined, documentId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Document/api/v1/document?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocument(_response);
        });
    }

    protected processDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    departments(token: string | null | undefined, customerId: string | null | undefined): Promise<DepartmentDto[]> {
        let url_ = this.baseUrl + "/Person/api/departments?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDepartments(_response);
        });
    }

    protected processDepartments(response: Response): Promise<DepartmentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDto[]>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    regulators(token: string | null | undefined, body: UserInfo | undefined): Promise<RegulatorDto[]> {
        let url_ = this.baseUrl + "/Person/api/regulators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegulators(_response);
        });
    }

    protected processRegulators(response: Response): Promise<RegulatorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegulatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegulatorDto[]>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param searchKey (optional) 
     * @param body (optional) 
     * @return Success
     */
    regulators2(token: string | null | undefined, searchKey: string | null | undefined, body: UserInfo | undefined): Promise<RegulatorDto[]> {
        let url_ = this.baseUrl + "/Person/api/search/regulators?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegulators2(_response);
        });
    }

    protected processRegulators2(response: Response): Promise<RegulatorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegulatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegulatorDto[]>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    persons(token: string | null | undefined, body: PersonSearchDto | undefined): Promise<UserInfo[]> {
        let url_ = this.baseUrl + "/Person/api/persons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersons(_response);
        });
    }

    protected processPersons(response: Response): Promise<UserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo[]>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(token: string | null | undefined, body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/person/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    lock(token: string | null | undefined, body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/person/lock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLock(_response);
        });
    }

    protected processLock(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    unlock(token: string | null | undefined, body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/person/unlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnlock(_response);
        });
    }

    protected processUnlock(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    person(token: string | null | undefined, body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPerson(_response);
        });
    }

    protected processPerson(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    standin(token: string | null | undefined, body: UserInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Person/api/person/standin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandin(_response);
        });
    }

    protected processStandin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param userId (optional) 
     * @return Success
     */
    ratings(token: string | null | undefined, userId: number | undefined): Promise<RatingDto[]> {
        let url_ = this.baseUrl + "/Rating/api/ratings?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRatings(_response);
        });
    }

    protected processRatings(response: Response): Promise<RatingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RatingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RatingDto[]>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    rating(token: string | null | undefined, body: RatingDto | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Rating/api/rating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRating(_response);
        });
    }

    protected processRating(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @return Success
     */
    receipt(token: string | null | undefined, receiptId: string | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + "/Receipt/api/receipt?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReceipt(_response);
        });
    }

    protected processReceipt(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @return Success
     */
    guid2(token: string | null | undefined, receiptId: string | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/guid?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGuid2(_response);
        });
    }

    protected processGuid2(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @return Success
     */
    common(token: string | null | undefined, receiptId: string | undefined): Promise<ReceiptDto> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/common?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCommon(_response);
        });
    }

    protected processCommon(response: Response): Promise<ReceiptDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param id (optional) 
     * @param key (optional) 
     * @return Success
     */
    report(token: string | null | undefined, id: number | undefined, key: string | null | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/Receipt/api/report?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @return Success
     */
    document2(token: string | null | undefined, receiptId: string | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/Receipt/api/document?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocument2(_response);
        });
    }

    protected processDocument2(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(token: string | null | undefined, body: ReceiptSearchDto | undefined): Promise<ReceiptSearchListDto> {
        let url_ = this.baseUrl + "/Receipt/api/receipts/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ReceiptSearchListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSearchListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceiptSearchListDto>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receipId (optional) 
     * @return Success
     */
    delete(token: string | null | undefined, receipId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/delete?";
        if (receipId === null)
            throw new Error("The parameter 'receipId' cannot be null.");
        else if (receipId !== undefined)
            url_ += "receipId=" + encodeURIComponent("" + receipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    save(token: string | null | undefined, body: ReceiptDto | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @param body (optional) 
     * @return Success
     */
    mail(token: string | null | undefined, receiptId: string | undefined, body: EmailDto | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/mail?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    finish(token: string | null | undefined, body: ReceiptDto | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/finish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinish(_response);
        });
    }

    protected processFinish(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param receiptId (optional) 
     * @param regulatorId (optional) 
     * @return Success
     */
    setregulator(token: string | null | undefined, receiptId: string | undefined, regulatorId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/setregulator?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        if (regulatorId === null)
            throw new Error("The parameter 'regulatorId' cannot be null.");
        else if (regulatorId !== undefined)
            url_ += "regulatorId=" + encodeURIComponent("" + regulatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetregulator(_response);
        });
    }

    protected processSetregulator(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param damageNumber (optional) 
     * @param userId (optional) 
     * @return Success
     */
    assign(token: string | null | undefined, damageNumber: string | null | undefined, userId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Receipt/api/receipt/assign?";
        if (damageNumber !== undefined && damageNumber !== null)
            url_ += "damageNumber=" + encodeURIComponent("" + damageNumber) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssign(_response);
        });
    }

    protected processAssign(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return Success
     */
    reporting(token: string | null | undefined, body: ReportingSearchDto | undefined): Promise<ReportingDto[]> {
        let url_ = this.baseUrl + "/Reporting/api/reporting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReporting(_response);
        });
    }

    protected processReporting(response: Response): Promise<ReportingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportingDto[]>(<any>null);
    }
}

export class AuthenticateRequest implements IAuthenticateRequest {
    username!: string;
    password!: string;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }
}

export interface IAuthenticateRequest {
    username: string;
    password: string;
}

export class UserRoleInfo implements IUserRoleInfo {
    id?: number;
    roleName?: string | undefined;
    applicationName?: string | undefined;

    constructor(data?: IUserRoleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.applicationName = _data["applicationName"];
        }
    }

    static fromJS(data: any): UserRoleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["applicationName"] = this.applicationName;
        return data; 
    }
}

export interface IUserRoleInfo {
    id?: number;
    roleName?: string | undefined;
    applicationName?: string | undefined;
}

export class UserInfo implements IUserInfo {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    hashedPassword?: string | undefined;
    eMail?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    department?: string | undefined;
    teamlead?: boolean;
    customerId?: string | undefined;
    locked?: boolean;
    token?: string | undefined;
    isIntern?: boolean;
    customerIds?: string | undefined;
    guid?: string;
    roles?: UserRoleInfo[] | undefined;
    roleList?: string[] | undefined;
    customerList?: string[] | undefined;
    dateLockedFrom?: Date | undefined;
    dateLockedTo?: Date | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.hashedPassword = _data["hashedPassword"];
            this.eMail = _data["eMail"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.department = _data["department"];
            this.teamlead = _data["teamlead"];
            this.customerId = _data["customerId"];
            this.locked = _data["locked"];
            this.token = _data["token"];
            this.isIntern = _data["isIntern"];
            this.customerIds = _data["customerIds"];
            this.guid = _data["guid"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleInfo.fromJS(item));
            }
            if (Array.isArray(_data["roleList"])) {
                this.roleList = [] as any;
                for (let item of _data["roleList"])
                    this.roleList!.push(item);
            }
            if (Array.isArray(_data["customerList"])) {
                this.customerList = [] as any;
                for (let item of _data["customerList"])
                    this.customerList!.push(item);
            }
            this.dateLockedFrom = _data["dateLockedFrom"] ? new Date(_data["dateLockedFrom"].toString()) : <any>undefined;
            this.dateLockedTo = _data["dateLockedTo"] ? new Date(_data["dateLockedTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["password"] = this.password;
        data["hashedPassword"] = this.hashedPassword;
        data["eMail"] = this.eMail;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["department"] = this.department;
        data["teamlead"] = this.teamlead;
        data["customerId"] = this.customerId;
        data["locked"] = this.locked;
        data["token"] = this.token;
        data["isIntern"] = this.isIntern;
        data["customerIds"] = this.customerIds;
        data["guid"] = this.guid;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.roleList)) {
            data["roleList"] = [];
            for (let item of this.roleList)
                data["roleList"].push(item);
        }
        if (Array.isArray(this.customerList)) {
            data["customerList"] = [];
            for (let item of this.customerList)
                data["customerList"].push(item);
        }
        data["dateLockedFrom"] = this.dateLockedFrom ? this.dateLockedFrom.toISOString() : <any>undefined;
        data["dateLockedTo"] = this.dateLockedTo ? this.dateLockedTo.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserInfo {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    hashedPassword?: string | undefined;
    eMail?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    department?: string | undefined;
    teamlead?: boolean;
    customerId?: string | undefined;
    locked?: boolean;
    token?: string | undefined;
    isIntern?: boolean;
    customerIds?: string | undefined;
    guid?: string;
    roles?: UserRoleInfo[] | undefined;
    roleList?: string[] | undefined;
    customerList?: string[] | undefined;
    dateLockedFrom?: Date | undefined;
    dateLockedTo?: Date | undefined;
}

export class JwtClientToken implements IJwtClientToken {
    user?: UserInfo;
    readonly tokenString?: string | undefined;
    readonly expires?: Date;

    constructor(data?: IJwtClientToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserInfo.fromJS(_data["user"]) : <any>undefined;
            (<any>this).tokenString = _data["tokenString"];
            (<any>this).expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JwtClientToken {
        data = typeof data === 'object' ? data : {};
        let result = new JwtClientToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tokenString"] = this.tokenString;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IJwtClientToken {
    user?: UserInfo;
    tokenString?: string | undefined;
    expires?: Date;
}

export class DepartmentDto implements IDepartmentDto {
    name?: string | undefined;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IDepartmentDto {
    name?: string | undefined;
}

export class RegulatorDto implements IRegulatorDto {
    userName?: string | undefined;
    guid?: string;
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IRegulatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.guid = _data["guid"];
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): RegulatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["guid"] = this.guid;
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data; 
    }
}

export interface IRegulatorDto {
    userName?: string | undefined;
    guid?: string;
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class PersonSearchDto implements IPersonSearchDto {
    customerId?: string | undefined;
    searchKey?: string | undefined;

    constructor(data?: IPersonSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.searchKey = _data["searchKey"];
        }
    }

    static fromJS(data: any): PersonSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["searchKey"] = this.searchKey;
        return data; 
    }
}

export interface IPersonSearchDto {
    customerId?: string | undefined;
    searchKey?: string | undefined;
}

export class RatingDto implements IRatingDto {
    receiptId?: number;
    personId?: number;
    receiptNumber?: string | undefined;
    damageNumber?: string | undefined;
    damageLocation?: string | undefined;
    partnerName?: string | undefined;
    globalGuid?: string | undefined;
    extReceiptNumber?: string | undefined;
    claimantLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    damageStreet?: string | undefined;
    damageZipCode?: string | undefined;
    damageDate?: string | undefined;
    regulator?: string | undefined;
    star1?: number;
    star2?: number;
    star3?: number;
    star4?: number;
    partnerId?: number;
    comment?: string | undefined;
    uniqueId?: string;

    constructor(data?: IRatingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.personId = _data["personId"];
            this.receiptNumber = _data["receiptNumber"];
            this.damageNumber = _data["damageNumber"];
            this.damageLocation = _data["damageLocation"];
            this.partnerName = _data["partnerName"];
            this.globalGuid = _data["globalGuid"];
            this.extReceiptNumber = _data["extReceiptNumber"];
            this.claimantLastName = _data["claimantLastName"];
            this.claimantFirstName = _data["claimantFirstName"];
            this.damageStreet = _data["damageStreet"];
            this.damageZipCode = _data["damageZipCode"];
            this.damageDate = _data["damageDate"];
            this.regulator = _data["regulator"];
            this.star1 = _data["star1"];
            this.star2 = _data["star2"];
            this.star3 = _data["star3"];
            this.star4 = _data["star4"];
            this.partnerId = _data["partnerId"];
            this.comment = _data["comment"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): RatingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RatingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["personId"] = this.personId;
        data["receiptNumber"] = this.receiptNumber;
        data["damageNumber"] = this.damageNumber;
        data["damageLocation"] = this.damageLocation;
        data["partnerName"] = this.partnerName;
        data["globalGuid"] = this.globalGuid;
        data["extReceiptNumber"] = this.extReceiptNumber;
        data["claimantLastName"] = this.claimantLastName;
        data["claimantFirstName"] = this.claimantFirstName;
        data["damageStreet"] = this.damageStreet;
        data["damageZipCode"] = this.damageZipCode;
        data["damageDate"] = this.damageDate;
        data["regulator"] = this.regulator;
        data["star1"] = this.star1;
        data["star2"] = this.star2;
        data["star3"] = this.star3;
        data["star4"] = this.star4;
        data["partnerId"] = this.partnerId;
        data["comment"] = this.comment;
        data["uniqueId"] = this.uniqueId;
        return data; 
    }
}

export interface IRatingDto {
    receiptId?: number;
    personId?: number;
    receiptNumber?: string | undefined;
    damageNumber?: string | undefined;
    damageLocation?: string | undefined;
    partnerName?: string | undefined;
    globalGuid?: string | undefined;
    extReceiptNumber?: string | undefined;
    claimantLastName?: string | undefined;
    claimantFirstName?: string | undefined;
    damageStreet?: string | undefined;
    damageZipCode?: string | undefined;
    damageDate?: string | undefined;
    regulator?: string | undefined;
    star1?: number;
    star2?: number;
    star3?: number;
    star4?: number;
    partnerId?: number;
    comment?: string | undefined;
    uniqueId?: string;
}

export class PropertyExpertDataDto implements IPropertyExpertDataDto {
    orderNumber?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    totalPrice?: number;

    constructor(data?: IPropertyExpertDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
            this.contactPerson = _data["contactPerson"];
            this.phoneNumber = _data["phoneNumber"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): PropertyExpertDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyExpertDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["contactPerson"] = this.contactPerson;
        data["phoneNumber"] = this.phoneNumber;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }
}

export interface IPropertyExpertDataDto {
    orderNumber?: string | undefined;
    contactPerson?: string | undefined;
    phoneNumber?: string | undefined;
    totalPrice?: number;
}

export class DamageDataDto implements IDamageDataDto {
    damageType?: string | undefined;
    damageCause?: string | undefined;

    constructor(data?: IDamageDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.damageType = _data["damageType"];
            this.damageCause = _data["damageCause"];
        }
    }

    static fromJS(data: any): DamageDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DamageDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["damageType"] = this.damageType;
        data["damageCause"] = this.damageCause;
        return data; 
    }
}

export interface IDamageDataDto {
    damageType?: string | undefined;
    damageCause?: string | undefined;
}

export class ExpertiseCheckDataDto implements IExpertiseCheckDataDto {
    amount?: number | undefined;
    unitPrice?: number | undefined;
    totalPrice?: number | undefined;

    constructor(data?: IExpertiseCheckDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): ExpertiseCheckDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertiseCheckDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }
}

export interface IExpertiseCheckDataDto {
    amount?: number | undefined;
    unitPrice?: number | undefined;
    totalPrice?: number | undefined;
}

export class ReceiptPositionDto implements IReceiptPositionDto {
    id?: number;
    description?: string | undefined;
    unit?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;
    inputData?: ExpertiseCheckDataDto;
    expertiseCheckData?: ExpertiseCheckDataDto;
    partnerData?: ExpertiseCheckDataDto;
    position?: string | undefined;

    constructor(data?: IReceiptPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.comment = _data["comment"];
            this.type = _data["type"];
            this.inputData = _data["inputData"] ? ExpertiseCheckDataDto.fromJS(_data["inputData"]) : <any>undefined;
            this.expertiseCheckData = _data["expertiseCheckData"] ? ExpertiseCheckDataDto.fromJS(_data["expertiseCheckData"]) : <any>undefined;
            this.partnerData = _data["partnerData"] ? ExpertiseCheckDataDto.fromJS(_data["partnerData"]) : <any>undefined;
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ReceiptPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["comment"] = this.comment;
        data["type"] = this.type;
        data["inputData"] = this.inputData ? this.inputData.toJSON() : <any>undefined;
        data["expertiseCheckData"] = this.expertiseCheckData ? this.expertiseCheckData.toJSON() : <any>undefined;
        data["partnerData"] = this.partnerData ? this.partnerData.toJSON() : <any>undefined;
        data["position"] = this.position;
        return data; 
    }
}

export interface IReceiptPositionDto {
    id?: number;
    description?: string | undefined;
    unit?: string | undefined;
    comment?: string | undefined;
    type?: string | undefined;
    inputData?: ExpertiseCheckDataDto;
    expertiseCheckData?: ExpertiseCheckDataDto;
    partnerData?: ExpertiseCheckDataDto;
    position?: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id?: number;
    key?: string | undefined;
    documentType?: string | undefined;
    content?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.documentType = _data["documentType"];
            this.content = _data["content"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["documentType"] = this.documentType;
        data["content"] = this.content;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IDocumentDto {
    id?: number;
    key?: string | undefined;
    documentType?: string | undefined;
    content?: string | undefined;
    fileName?: string | undefined;
}

export class ReceiptDto implements IReceiptDto {
    id?: number;
    refBelegId?: number;
    damageId?: number;
    number?: string | undefined;
    damageNumber?: string | undefined;
    claimant?: string | undefined;
    regulator?: string | undefined;
    regulatorId?: string;
    receiptDate?: string | undefined;
    inputDate?: Date | undefined;
    state?: string | undefined;
    partner?: string | undefined;
    documentType?: string | undefined;
    propertyExpertData?: PropertyExpertDataDto;
    damageData?: DamageDataDto;
    receiptPositions?: ReceiptPositionDto[] | undefined;
    craftsman?: string | undefined;
    reviewerId?: number;
    nichtGeprueft?: boolean;
    comment?: string | undefined;
    reviewerName?: string | undefined;
    expertiserId?: number;
    endResult?: boolean;
    negotiation?: string | undefined;
    resultInformation?: string | undefined;
    uniqueId?: string;
    totalInputPrice?: number;
    totalExpertPrice?: number;
    totalPartnerPrice?: number;
    differancePrice?: number;
    finish?: Date | undefined;
    finishText?: string | undefined;
    documentKey?: string | undefined;
    outputMail?: string | undefined;
    documents?: DocumentDto[] | undefined;
    refSchadenId?: number;
    inputDateText?: string | undefined;
    partnerNumber?: string | undefined;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refBelegId = _data["refBelegId"];
            this.damageId = _data["damageId"];
            this.number = _data["number"];
            this.damageNumber = _data["damageNumber"];
            this.claimant = _data["claimant"];
            this.regulator = _data["regulator"];
            this.regulatorId = _data["regulatorId"];
            this.receiptDate = _data["receiptDate"];
            this.inputDate = _data["inputDate"] ? new Date(_data["inputDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.partner = _data["partner"];
            this.documentType = _data["documentType"];
            this.propertyExpertData = _data["propertyExpertData"] ? PropertyExpertDataDto.fromJS(_data["propertyExpertData"]) : <any>undefined;
            this.damageData = _data["damageData"] ? DamageDataDto.fromJS(_data["damageData"]) : <any>undefined;
            if (Array.isArray(_data["receiptPositions"])) {
                this.receiptPositions = [] as any;
                for (let item of _data["receiptPositions"])
                    this.receiptPositions!.push(ReceiptPositionDto.fromJS(item));
            }
            this.craftsman = _data["craftsman"];
            this.reviewerId = _data["reviewerId"];
            this.nichtGeprueft = _data["nichtGeprueft"];
            this.comment = _data["comment"];
            this.reviewerName = _data["reviewerName"];
            this.expertiserId = _data["expertiserId"];
            this.endResult = _data["endResult"];
            this.negotiation = _data["negotiation"];
            this.resultInformation = _data["resultInformation"];
            this.uniqueId = _data["uniqueId"];
            this.totalInputPrice = _data["totalInputPrice"];
            this.totalExpertPrice = _data["totalExpertPrice"];
            this.totalPartnerPrice = _data["totalPartnerPrice"];
            this.differancePrice = _data["differancePrice"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : <any>undefined;
            this.finishText = _data["finishText"];
            this.documentKey = _data["documentKey"];
            this.outputMail = _data["outputMail"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.refSchadenId = _data["refSchadenId"];
            this.inputDateText = _data["inputDateText"];
            this.partnerNumber = _data["partnerNumber"];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refBelegId"] = this.refBelegId;
        data["damageId"] = this.damageId;
        data["number"] = this.number;
        data["damageNumber"] = this.damageNumber;
        data["claimant"] = this.claimant;
        data["regulator"] = this.regulator;
        data["regulatorId"] = this.regulatorId;
        data["receiptDate"] = this.receiptDate;
        data["inputDate"] = this.inputDate ? this.inputDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["partner"] = this.partner;
        data["documentType"] = this.documentType;
        data["propertyExpertData"] = this.propertyExpertData ? this.propertyExpertData.toJSON() : <any>undefined;
        data["damageData"] = this.damageData ? this.damageData.toJSON() : <any>undefined;
        if (Array.isArray(this.receiptPositions)) {
            data["receiptPositions"] = [];
            for (let item of this.receiptPositions)
                data["receiptPositions"].push(item.toJSON());
        }
        data["craftsman"] = this.craftsman;
        data["reviewerId"] = this.reviewerId;
        data["nichtGeprueft"] = this.nichtGeprueft;
        data["comment"] = this.comment;
        data["reviewerName"] = this.reviewerName;
        data["expertiserId"] = this.expertiserId;
        data["endResult"] = this.endResult;
        data["negotiation"] = this.negotiation;
        data["resultInformation"] = this.resultInformation;
        data["uniqueId"] = this.uniqueId;
        data["totalInputPrice"] = this.totalInputPrice;
        data["totalExpertPrice"] = this.totalExpertPrice;
        data["totalPartnerPrice"] = this.totalPartnerPrice;
        data["differancePrice"] = this.differancePrice;
        data["finish"] = this.finish ? this.finish.toISOString() : <any>undefined;
        data["finishText"] = this.finishText;
        data["documentKey"] = this.documentKey;
        data["outputMail"] = this.outputMail;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["refSchadenId"] = this.refSchadenId;
        data["inputDateText"] = this.inputDateText;
        data["partnerNumber"] = this.partnerNumber;
        return data; 
    }
}

export interface IReceiptDto {
    id?: number;
    refBelegId?: number;
    damageId?: number;
    number?: string | undefined;
    damageNumber?: string | undefined;
    claimant?: string | undefined;
    regulator?: string | undefined;
    regulatorId?: string;
    receiptDate?: string | undefined;
    inputDate?: Date | undefined;
    state?: string | undefined;
    partner?: string | undefined;
    documentType?: string | undefined;
    propertyExpertData?: PropertyExpertDataDto;
    damageData?: DamageDataDto;
    receiptPositions?: ReceiptPositionDto[] | undefined;
    craftsman?: string | undefined;
    reviewerId?: number;
    nichtGeprueft?: boolean;
    comment?: string | undefined;
    reviewerName?: string | undefined;
    expertiserId?: number;
    endResult?: boolean;
    negotiation?: string | undefined;
    resultInformation?: string | undefined;
    uniqueId?: string;
    totalInputPrice?: number;
    totalExpertPrice?: number;
    totalPartnerPrice?: number;
    differancePrice?: number;
    finish?: Date | undefined;
    finishText?: string | undefined;
    documentKey?: string | undefined;
    outputMail?: string | undefined;
    documents?: DocumentDto[] | undefined;
    refSchadenId?: number;
    inputDateText?: string | undefined;
    partnerNumber?: string | undefined;
}

export enum SortEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum SortDirection {
    _0 = 0,
    _1 = 1,
}

export class ReceiptSearchDto implements IReceiptSearchDto {
    userId?: number;
    teamLead?: boolean;
    customerId?: string | undefined;
    regulatorName?: string | undefined;
    damageNumber?: string | undefined;
    abgeschlossen?: boolean;
    wartend?: boolean;
    currentPage?: number;
    department?: string | undefined;
    sortBy?: SortEnum;
    sortDirection?: SortDirection;
    documentType?: string | undefined;
    regulator?: string | undefined;
    partner?: string | undefined;
    ownReceipts?: boolean;

    constructor(data?: IReceiptSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.teamLead = _data["teamLead"];
            this.customerId = _data["customerId"];
            this.regulatorName = _data["regulatorName"];
            this.damageNumber = _data["damageNumber"];
            this.abgeschlossen = _data["abgeschlossen"];
            this.wartend = _data["wartend"];
            this.currentPage = _data["currentPage"];
            this.department = _data["department"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.documentType = _data["documentType"];
            this.regulator = _data["regulator"];
            this.partner = _data["partner"];
            this.ownReceipts = _data["ownReceipts"];
        }
    }

    static fromJS(data: any): ReceiptSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["teamLead"] = this.teamLead;
        data["customerId"] = this.customerId;
        data["regulatorName"] = this.regulatorName;
        data["damageNumber"] = this.damageNumber;
        data["abgeschlossen"] = this.abgeschlossen;
        data["wartend"] = this.wartend;
        data["currentPage"] = this.currentPage;
        data["department"] = this.department;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["documentType"] = this.documentType;
        data["regulator"] = this.regulator;
        data["partner"] = this.partner;
        data["ownReceipts"] = this.ownReceipts;
        return data; 
    }
}

export interface IReceiptSearchDto {
    userId?: number;
    teamLead?: boolean;
    customerId?: string | undefined;
    regulatorName?: string | undefined;
    damageNumber?: string | undefined;
    abgeschlossen?: boolean;
    wartend?: boolean;
    currentPage?: number;
    department?: string | undefined;
    sortBy?: SortEnum;
    sortDirection?: SortDirection;
    documentType?: string | undefined;
    regulator?: string | undefined;
    partner?: string | undefined;
    ownReceipts?: boolean;
}

export class PartnerDto implements IPartnerDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IPartnerDto {
    id?: number;
    name?: string | undefined;
}

export class ReceiptSearchListDto implements IReceiptSearchListDto {
    count?: number;
    receipts?: ReceiptDto[] | undefined;
    partners?: PartnerDto[] | undefined;

    constructor(data?: IReceiptSearchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptDto.fromJS(item));
            }
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiptSearchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSearchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReceiptSearchListDto {
    count?: number;
    receipts?: ReceiptDto[] | undefined;
    partners?: PartnerDto[] | undefined;
}

export class EmailDto implements IEmailDto {
    email?: string | undefined;
    emailCC?: string | undefined;
    emailTitle?: string | undefined;
    emailBody?: string | undefined;
    emailSendDocuments?: boolean;
    emailReport?: boolean;

    constructor(data?: IEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.emailCC = _data["emailCC"];
            this.emailTitle = _data["emailTitle"];
            this.emailBody = _data["emailBody"];
            this.emailSendDocuments = _data["emailSendDocuments"];
            this.emailReport = _data["emailReport"];
        }
    }

    static fromJS(data: any): EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["emailCC"] = this.emailCC;
        data["emailTitle"] = this.emailTitle;
        data["emailBody"] = this.emailBody;
        data["emailSendDocuments"] = this.emailSendDocuments;
        data["emailReport"] = this.emailReport;
        return data; 
    }
}

export interface IEmailDto {
    email?: string | undefined;
    emailCC?: string | undefined;
    emailTitle?: string | undefined;
    emailBody?: string | undefined;
    emailSendDocuments?: boolean;
    emailReport?: boolean;
}

export class ReportingSearchDto implements IReportingSearchDto {
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IReportingSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportingSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IReportingSearchDto {
    customerId?: string | undefined;
    dateFrom?: Date;
    dateTo?: Date;
}

export class ReportingEntry implements IReportingEntry {
    department?: string | undefined;
    id?: number;
    name?: string | undefined;
    claimCount?: number;
    averageFlowTime?: number;
    damageAmount?: number;
    reductionProperty?: number;
    reductionRegulator?: number;
    invoiceAmount?: number;

    constructor(data?: IReportingEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.claimCount = _data["claimCount"];
            this.averageFlowTime = _data["averageFlowTime"];
            this.damageAmount = _data["damageAmount"];
            this.reductionProperty = _data["reductionProperty"];
            this.reductionRegulator = _data["reductionRegulator"];
            this.invoiceAmount = _data["invoiceAmount"];
        }
    }

    static fromJS(data: any): ReportingEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department;
        data["id"] = this.id;
        data["name"] = this.name;
        data["claimCount"] = this.claimCount;
        data["averageFlowTime"] = this.averageFlowTime;
        data["damageAmount"] = this.damageAmount;
        data["reductionProperty"] = this.reductionProperty;
        data["reductionRegulator"] = this.reductionRegulator;
        data["invoiceAmount"] = this.invoiceAmount;
        return data; 
    }
}

export interface IReportingEntry {
    department?: string | undefined;
    id?: number;
    name?: string | undefined;
    claimCount?: number;
    averageFlowTime?: number;
    damageAmount?: number;
    reductionProperty?: number;
    reductionRegulator?: number;
    invoiceAmount?: number;
}

export class ReportingDto implements IReportingDto {
    groupName?: string | undefined;
    employees?: ReportingEntry[] | undefined;
    partner?: ReportingEntry[] | undefined;
    employeePartner?: ReportingEntry[] | undefined;

    constructor(data?: IReportingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(ReportingEntry.fromJS(item));
            }
            if (Array.isArray(_data["partner"])) {
                this.partner = [] as any;
                for (let item of _data["partner"])
                    this.partner!.push(ReportingEntry.fromJS(item));
            }
            if (Array.isArray(_data["employeePartner"])) {
                this.employeePartner = [] as any;
                for (let item of _data["employeePartner"])
                    this.employeePartner!.push(ReportingEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        if (Array.isArray(this.partner)) {
            data["partner"] = [];
            for (let item of this.partner)
                data["partner"].push(item.toJSON());
        }
        if (Array.isArray(this.employeePartner)) {
            data["employeePartner"] = [];
            for (let item of this.employeePartner)
                data["employeePartner"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReportingDto {
    groupName?: string | undefined;
    employees?: ReportingEntry[] | undefined;
    partner?: ReportingEntry[] | undefined;
    employeePartner?: ReportingEntry[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}